export default {
  isOfferFlowAddressAutoCompleteDisabled:
    (state) => state.isOfferAddressAutoCompleteDisabled,
};
